<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div>Cette interface vous permet valider les préinscriptions de {{
                            mainStore.module.nom }}.</div>
                        <ValidationPreInscriptionsListMAXIRACE26 v-if="mainStore.module.base == 'MAXIRACE26'">
                        </ValidationPreInscriptionsListMAXIRACE26>
                        <ValidationPreInscriptionsList v-else></ValidationPreInscriptionsList>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import ValidationPreInscriptionsListMAXIRACE26 from "@/components/Administration/PreInscrinscriptions/MAXIRACE26/ValidationPreInscriptionsList.vue";
import ValidationPreInscriptionsList from "@/components/Administration/PreInscrinscriptions/ValidationPreInscriptionsList.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    components: { ValidationPreInscriptionsListMAXIRACE26, ValidationPreInscriptionsList },
    computed: {
        ...mapStores(useMainStore),
    },
}
</script>

<style lang="scss" scoped></style>